// Vendors
import styled from 'styled-components';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';
// Utilities
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const ErrorProviderStyled = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing_250};
  max-width: ${convertPxsToRems({ pixels: 682, base: 16 })};
  margin: 0 auto;
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.onlyMobile} {
    margin: 0;
    max-width: 100%;
    padding: 0 ${({ theme }) => theme.spacing_250};
  }
`;
ErrorProviderStyled.displayName = 'ErrorProviderStyled';

export { ErrorProviderStyled };
